export default {
      id: "icon-shop-link-usage",
      viewBox: "0 0 16.89 19.25",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-shop-link",
      toString: function () {
        return this.url;
      }
    }